import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import LMS_STORE from './LMS_Redux/LMS_Store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={LMS_STORE} >
      <App />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);

